import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import DrivingSchoolSidebar from "./DrivingSchoolSidebar";
import DrivingSchoolHeader from "./DrivingSchoolHeader";
import { getSchoolRouteInfo } from "./GetSchoolRouteInfo";
import DrivingSchoolFooter from "./dashboard/DrivingSchoolFooter";
const DrivingSchoolLayout = () => {
  const location = useLocation();
  const { pageTitle, breadcrumbs } = getSchoolRouteInfo(location.pathname);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="d-flex dashboard-layout">
      
      {/* SIDEBAR */}
      <DrivingSchoolSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* OVERLAY (mobile only) */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* RIGHT SIDE */}
      <div className="flex-grow-1 d-flex flex-column">

        {/* HEADER */}
        <DrivingSchoolHeader
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          onMenuClick={() => setSidebarOpen(true)}
        />

        {/* CONTENT */}
        <div className="flex-grow-1 p-3 p-md-4 content-area">
          <Outlet />
        </div>
<DrivingSchoolFooter />
      </div>
    </div>
  );
};

export default DrivingSchoolLayout;
